import countries from './phone-number-countries'
import 'libphonenumber-js-utils'

export const getPhoneNumberCountry = phoneNumber => {
  return countries.find(country => phoneNumber.match(new RegExp(`^\\+${country.dialCode}`)))
}

export const formatPhoneNumber = phoneNumber => {
  return window.intlTelInputUtils.formatNumber(
    phoneNumber,
    getPhoneNumberCountry(phoneNumber).iso2,
    window.intlTelInputUtils.numberFormat.NATIONAL
  )
}

export const formatToInternationalPhoneNumber = (phoneNumber, countryCode) => {
  return window.intlTelInputUtils.formatNumber(
    phoneNumber,
    countryCode,
    window.intlTelInputUtils.numberFormat.INTERNATIONAL
  )
}

export default getPhoneNumberCountry
